import { createGlobalStyle } from 'styled-components';

//TODO allow for multiple sources and font family
const GlobalStyle = createGlobalStyle`
  :root {
    font-family: 'Inter', sans-serif;
    overflow-y: hidden;

  }
  * {
    font-family: 'Inter', sans-serif;
  }

  body {
    background-color: ${(props) => props.theme.color.background};
    font-family: 'Inter', sans-serif;
  }
  a{
    text-decoration:none;
  }

 
  p,h3,h1{
    margin-block-start:0px;
    margin-block-end:0px;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
body::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
body {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
`;

export default GlobalStyle;

// .disableTextSelection {
//   -webkit-touch-callout: none;
//   /* iOS Safari */
//   -webkit-user-select: none;
//   /* Safari */
//   -khtml-user-select: none;
//   /* Konqueror HTML */
//   -moz-user-select: none;
//   /* Old versions of Firefox */
//   -ms-user-select: none;
//   /* Internet Explorer/Edge */
//   user-select: none;
//   /* Non-prefixed version, currently
